<template>
  <div class="cmp-contact-form-user-new">
    <ws-input
      v-model="value.email"
      name="email"
      class="full-width"
      :label="$t('uikit:profile.email.label')"
      :path="'scf.contact.email'"
      autocomplete="email"
      required
      :rules="[required, ...propStaticRules['email']]"
    />
    <ws-input
      v-model="value.name"
      name="name"
      class="full-width"
      :label="$t('uikit:address.name.label')"
      :path="'scf.contact.name'"
      autocomplete="name"
      :rules="[required, ...propStaticRules['name']]"
      :restrict="propRestriction['name']"
      required
    />
    <ws-input
      key="organisation"
      v-model="value.organisation"
      name="organisation"
      class="full-width"
      :label="$t('uikit:address.organisation.label')"
      :path="'scf.contact.organisation'"
      autocomplete="organization"
      optional-text
      :rules="propStaticRules['organisation']"
    />
    <ws-phone-input
      v-model="value.phone"
      name="phone"
      class="full-width"
      :placeholder="$t('uikit:profile.phone.label')"
      :path="'scf.contact.phone'"
      autocomplete="tel-local"
      required
      :rules="[required]"
      messages-overflow
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  required,
  propertyValidation,
  addressPropertyList,
  addValidations,
} from '@/services/validation/validation.service.ts';
import type { Validator } from '@/services/validation/validation.service.d';
import WsInput from '@WS_Components/WsInput.vue';
import WsPhoneInput from '@WS_Components/WsPhoneInput.vue';
import { EditableAddressProps } from '@/components/WsAddress.enum';

@Component({
  components: {
    WsInput,
    WsPhoneInput,
  },
})
export default class ContactFormUserNew extends Vue {
  @Prop({ default: () => ({}) })
  readonly value!: any;

  required = required;
  propStaticRules: Record<EditableAddressProps, Validator[]> = Object.create(
    null
  );
  propRestriction: Record<EditableAddressProps, string> = Object.create(null);

  created() {
    addValidations([addressPropertyList]);
    (['email', 'name', 'organisation'] as EditableAddressProps[]).forEach(
      prop => {
        const { rules, restriction } = propertyValidation(`address_${prop}`);
        this.propStaticRules[prop] = rules;
        this.propRestriction[prop] = restriction;
      }
    );
  }
}
</script>
